import React from 'react';
import Icon from 'components/helpers/Icon';
import { useI18n } from 'next-localization';
import classNames from 'classnames/bind';
import styles from './PlanOptionsListingGraphQL/PlanOptionsListingGraphQL.module.scss';

export type StarRatingProps = {
  ratingValue: number;
  itemKey: string;
  className: string;
  iconClassName: string;
};

const StarRating: React.FC<StarRatingProps> = (props) => {
  const cx = classNames.bind(styles);
  const { t } = useI18n();

  const { ratingValue, itemKey, iconClassName, className } = props;

  if (!ratingValue) {
    return <></>;
  }

  const stars = [];
  const $halfStarClassName = `${iconClassName}--half`;

  for (let num = 0; num < ratingValue; num++) {
    stars.push(
      <Icon
        className={cx(iconClassName, ratingValue - num === 0.5 ? $halfStarClassName : '')}
        key={`${itemKey}-star-${num}`}
        variant="star-filled"
      />
    );
  }

  return ratingValue ? (
    <span
      role="img"
      aria-label={t('Aria-Start-Rating').replace('[rating]', ratingValue.toString())}
      className={cx(className)}
    >
      {stars}
    </span>
  ) : (
    <></>
  );
};

export default StarRating;
